/* CNC slider position indicator (2026-11-02, preview v3.3)
   Segmented: one dash per product; red dashes = the products actually visible on screen
   (read from slick's .slick-active slides, so it is always correct, also on mobile).
   Rows with more than 12 products fall back to a smooth bar.
   v3.3: on rows with the indicator, the theme's hidden dots space is removed (mobile gap fix). */
(function(){
  var MAXSEG=12;
  var css=''+
  '.products-carousel.cnc-has-ind.slick-dotted{margin-bottom:0!important}'+
  '.products-carousel.cnc-has-ind .slick-dots{display:none!important}'+
  '.cnc-pind{width:100%;margin:24px 0 6px;display:flex;gap:6px}'+
  '.cnc-pind.hid{display:none!important}'+
  '.cnc-pind>b{display:block;flex:1 1 0;min-width:0;height:4px;border-radius:4px;background:#c4c4c4;transition:background-color .35s ease}'+
  '.cnc-pind>b.on{background:#d71920}'+
  '.cnc-pind.smooth{position:relative;display:block;height:4px;border-radius:4px;background:#c4c4c4;overflow:hidden}'+
  '.cnc-pind.smooth>i{position:absolute;top:0;left:0;height:100%;border-radius:4px;background:#d71920;transition:left .45s cubic-bezier(.25,.8,.25,1),width .3s}'+
  '@media(max-width:749px){.cnc-pind{gap:4px;margin:16px 0 28px}.cnc-pind>b,.cnc-pind.smooth{height:3px}}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);
  function visible($s,n){
    var idx=[];$s.find('.slick-slide.slick-active').each(function(){var i=parseInt(this.getAttribute('data-slick-index'),10);if(!isNaN(i)){i=((i%n)+n)%n;if(idx.indexOf(i)<0)idx.push(i);}});
    return idx;
  }
  function attach(){
    if(!window.jQuery||!jQuery.fn.slick)return;
    jQuery('.products-carousel.slick-initialized').each(function(){
      var $s=jQuery(this);if($s.data('cncind'))return;$s.data('cncind',1);$s.addClass('cnc-has-ind');
      var $ind=jQuery('<div class="cnc-pind" aria-hidden="true"></div>');$s.after($ind);
      var built=-1,mode='';
      function upd(){
        var sk;try{sk=$s.slick('getSlick');}catch(e){return;}if(!sk)return;
        var n=sk.slideCount,vis=visible($s,n);if(!vis.length){var c=sk.currentSlide||0,sh=Math.min(sk.options.slidesToShow||1,n);for(var q=0;q<sh;q++)vis.push((c+q)%n);}
        var show=vis.length;
        $ind.toggleClass('hid',n<=show);if(n<=show)return;
        if(n>MAXSEG){
          if(mode!=='smooth'){$ind.empty().addClass('smooth').append('<i></i>');mode='smooth';built=-1;}
          var first=Math.min.apply(null,vis),w=show/n*100,maxL=100-w,l=Math.min(maxL,Math.max(0,first/(n-show)*maxL));
          $ind.find('i').css({width:w+'%',left:l+'%'});return;
        }
        if(mode!=='seg'||built!==n){$ind.removeClass('smooth').empty();for(var k=0;k<n;k++)$ind.append('<b></b>');built=n;mode='seg';}
        var segs=$ind.children('b');segs.removeClass('on');
        for(var j=0;j<vis.length;j++)segs.eq(vis[j]).addClass('on');
      }
      $s.on('afterChange setPosition breakpoint reInit',function(){setTimeout(upd,0);});upd();
    });
  }
  var t=0,iv=setInterval(function(){attach();if(++t>120)clearInterval(iv);},1000);
  window.addEventListener('scroll',attach,{passive:true});
  document.addEventListener('DOMContentLoaded',attach);
})();
